import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { readStaffHandover } from '@riskpay/ui-components';
import { App } from './App';
import { useAuth } from './lib/client';
import './index.css';

/*
 * A session handed over by the Quantum panel's "open dashboard", applied before
 * React exists.
 *
 * This deliberately does not live inside a component. The first attempt read
 * the fragment from a useState initializer, which runs during render — React
 * discards state written in that phase, and under StrictMode the initializer
 * runs twice, so the second pass found a fragment the first had already
 * cleared. The session silently never arrived and the staff member was shown
 * the sign-in screen.
 *
 * Out here it runs exactly once, before the first render, so the app's very
 * first paint is already the merchant's dashboard.
 */
const handover = readStaffHandover();
if (handover) useAuth.getState().signIn(handover);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
